import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {RegionalCore} from '../models';
import {ApiService} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class RegionalService extends ApiService<RegionalCore> {
  protected objectKey = 'DatosRegionales';
  protected dataKey = 'Regionales';

  constructor(protected httpClient: HttpClient) {
    super(RegionalCore, httpClient);
  }
}
